// biome-ignore lint/complexity/noBannedTypes: It's a decorator.
export function sealed(constructor_: Function) {
  Object.seal(constructor_)
  Object.seal(constructor_.prototype)
}
